import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory, useParams } from 'react-router-dom';
import { Logo } from '../../components/ui/Logo';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { useGetQueryParams } from '../../utils/useGetQueryParameters';


const useStyles = makeStyles((theme: any) => ({
    content: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 200,
        width: "100%",
        height: "100%",
        flexDirection: 'column',
        rowGap: 25,

    },
    loader: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        zIndex: 200,
    },
}));

export const VerifyUser = () => {
    const classes = useStyles()
    const history = useHistory()
    const query = useGetQueryParams();
    const [isVerifyingUser, setVerifyingUser] = useState(false)
    const { email, token } = useParams<{ email?: string, token?: string}>();

    useEffect(() => {
        setVerifyParameters()
    },[])

    function setVerifyParameters(){
        if(email && token){
            setVerifyingUser(true)
            verifyUser(email,token)
        } else {
            toast.error("Failed verification of user")
            localStorage.clear()
            history.push("")
        }
    }

    function verifyUser(tmpEmail: string, tmpEmailVerificationToken: string){
        planEatApi.postVerifyEmail(tmpEmail, tmpEmailVerificationToken)
            .then(() => {
                toast.success("Successfully verified user")
                history.push("/signUpInfo")
            })
            .catch((e) => {
                toast.error("Failed verifying user")
                localStorage.clear()
                history.push("")
            })
    }

    return (
        <div className={classes.content}>
            <Logo variant='normal' />   
            {
                isVerifyingUser &&
                <div>
                    <h4>
                        Verifying {query.get("email") ? query.get("email") : ""}...
                    </h4>
                    <div className={classes.loader}>
                        <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    </div>
                </div>                
            }
        </div>
    )
}
